<template>
  <div>
    <section class="officer-open-recruitment-apply-list ly-list">
      <div class="section-inner">
        <div class="section-cont">
          <h2>사관 &middot; 공채 지원 관리</h2>
          <p class="site-path">
            <span>Home</span>&nbsp;&gt;&nbsp;
            <span>EDUCATION</span>&nbsp;&gt;&nbsp;
            <span>사관 &middot; 공채 지원 관리</span>
          </p>

          <div class="apply-disabled">
            <div class="period-setting">
              <div class="period-header">
                <div>
                  <h3>접수 기간 설정</h3>
                  <p class="period-desc">
                    설정한 기간 안에서는 해당 구분이 <span style="color: #ee0000; font-weight: 600">신청 불가(비활성화)</span>되며, 기간 외에는 자동으로 활성화됩니다.
                  </p>
                </div>
              </div>

              <div class="period-grid">
                <!-- 사관학교 -->
                <div class="period-card">
                  <div class="period-title">
                    <span class="badge badge-officer">사관학교</span>
                    <span class="period-label">접수 기간</span>
                  </div>
                  <div class="period-inputs">
                    <input
                        type="date"
                        v-model="officer_start_date"
                        class="period-input"
                    />
                    <span class="tilde">~</span>
                    <input
                        type="date"
                        v-model="officer_end_date"
                        class="period-input"
                    />
                  </div>
                  <div class="period-actions">
                    <button type="button" class="btn-save" @click="saveOfficerPeriod">
                      저장
                    </button>
                  </div>
                </div>

                <!-- 코디네이터 -->
                <div class="period-card">
                  <div class="period-title">
                    <span class="badge badge-coord">코디네이터</span>
                    <span class="period-label">접수 기간</span>
                  </div>
                  <div class="period-inputs">
                    <input
                        type="date"
                        v-model="coord_start_date"
                        class="period-input"
                    />
                    <span class="tilde">~</span>
                    <input
                        type="date"
                        v-model="coord_end_date"
                        class="period-input"
                    />
                  </div>
                  <div class="period-actions">
                    <button type="button" class="btn-save" @click="saveCoordPeriod">
                      저장
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.site-path -->
          <ul class="tab-menu store-tab-menu">
            <li>
              <button
                  v-bind:class="{ checked: apply_type == 0 }"
                  @click="onButtonApplyType(0)"
              >
                전체
              </button>
            </li>
            <li>
              <button
                  v-bind:class="{ checked: JSON.stringify(apply_type) === JSON.stringify([1,2,4]) }"
                  @click="onButtonApplyType([1,2,4]);"
              >
                사관학교
              </button>
            </li>


            <!--            <li>-->
            <!--              <button-->
            <!--                v-bind:class="{ checked: apply_type == 1 }"-->
            <!--                @click="onButtonApplyType(1)"-->
            <!--              >-->
            <!--                사관-->
            <!--              </button>-->
            <!--            </li>-->
            <!--            <li>-->
            <!--              <button-->
            <!--                v-bind:class="{ checked: apply_type == 2 }"-->
            <!--                @click="onButtonApplyType(2)"-->
            <!--              >-->
            <!--                공채-->
            <!--              </button>-->
            <!--            </li>-->


            <li>
              <button
                v-bind:class="{ checked: apply_type == 3 }"
                @click="onButtonApplyType(3)"
              >
                코디네이터
              </button>
            </li>
          </ul>
          <!-- /.tab menu-->

          <p class="total-post">
            전체 게시물 <span>{{ getDataTotalCount }}</span
            >개
          </p>
          <!-- /.total-post -->
          <search-input :searchHandler="onSearch" class="search-top-175 recruitment" />
          <!-- /.search -->
          <table>
            <colgroup>
              <col class="col1" />
              <col class="col2" />
              <col class="col3" />
              <col class="col4" />
              <col class="col5" />
              <col class="col6" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" class="check-cell">
                  <label for="" class="hidden">전체체크</label
                  ><input
                    type="checkbox"
                    @click="check()"
                    v-model="checkAllValue"
                  />
                  <div class="chk-icon-wrap">
                    <img
                      class="chk-icon"
                      src="../../../assets/image/icon-form-checkbox.jpg"
                      alt="icon checkbox"
                    />
                  </div>
                </th>
                <th scope="col">No.</th>
                <th scope="col">구분</th>
                <th scope="col">성함</th>
                <th scope="col">연락처</th>
                <th scope="col">등록일</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in getData" v-bind:key="item.id">
                <td class="check-cell">
                  <label for="" class="hidden">조직 체크</label
                  ><input
                    type="checkbox"
                    v-model="checkedValues"
                    :value="item.id"
                  />
                  <div class="chk-icon-wrap">
                    <img
                      class="chk-icon"
                      src="../../../assets/image/icon-form-checkbox.jpg"
                      alt="icon checkbox"
                    />
                  </div>
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'OfficerOpenRecruitmentApplyShow',
                      params: { id: item.id, item: item },
                    }"
                  >
                    {{ item.id }}
                  </router-link>
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'OfficerOpenRecruitmentApplyShow',
                      params: { id: item.id, item: item },
                    }"
                  >
                    {{ getTypeName(item.type) }}
                  </router-link>
                </td>
                <td class="">
                  <router-link
                    :to="{
                      name: 'OfficerOpenRecruitmentApplyShow',
                      params: { id: item.id, item: item },
                    }"
                  >
                    {{ maskingFuncName(item.name) }}
                  </router-link>
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'OfficerOpenRecruitmentApplyShow',
                      params: { id: item.id, item: item },
                    }"
                  >
                    {{ maskingFuncPhone(item.mobile_no) }}
                  </router-link>
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'OfficerOpenRecruitmentApplyShow',
                      params: { id: item.id, item: item },
                    }"
                  >
                    {{ $moment(item.created_dttm).format("YYYY.MM.DD") }}
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- /.table-->
          <div class="page">
            <paginate
              :pageCount="totalPages"
              :pageRange="10"
              :clickHandler="handlePageSelected"
            ></paginate>
          </div>
          <!-- /.paginate -->
          <button class="btn-icon-del btn-right" @click="onConfirmDelete">
            <img src="../../../assets/image/btn-del.png" alt="delete icon" />
            <span>선택삭제</span>
          </button>
          <!-- /.btn -->
        </div>

        <app-footer />
      </div>
    </section>
  </div>
</template>

<script>
import axios from '@/api/axios-auth';
import AppFooter from "../../AppFooter.vue";
import Paginate from "../../Paginate.vue";
import SearchInput from "../../SearchInput.vue";

export default {
  components: { AppFooter, Paginate, SearchInput },
  name: "OfficerOpenRecruitmentApplyList",
  data() {
    return {
      // 접수 비활성화 기간
      officer_start_date: "",
      officer_end_date: "",
      coord_start_date: "",
      coord_end_date: "",
      // 기존 리스트 관련
      apply_type: 0,
      data_list: [],
      data_total_count: 0,
      checkedValues: [],
      searchtext: "",
    };
  },
  computed: {
    getData: function () {
      return this.data_list;
    },
    getDataTotalCount: function () {
      return this.data_total_count;
    },
  },
  created() {
    this.loadData({
      page: 1,
      size: this.PAGE_SIZE,
    });
    this.loadPeriodConfig();
  },
  methods: {
    // ==========================
    // 공통 helper
    // ==========================
    isValidDateStr(str) {
      if (!str) return false;
      const reg = /^\d{4}-\d{2}-\d{2}$/;
      if (!reg.test(str)) return false;
      const d = new Date(str);
      return !Number.isNaN(d.getTime());
    },
    isRangeOverlapped(aStart, aEnd, bStart, bEnd) {
      if (!aStart || !aEnd || !bStart || !bEnd) return false;
      // YYYY-MM-DD는 문자열 비교로도 순서가 맞음
      return !(aEnd < bStart || bEnd < aStart);
    },

    // ==========================
    // 기간 설정값 조회 (admin)
    // GET /api/v1/education/officeropenrecruitment/apply/dateconfig
    // ==========================
    async loadPeriodConfig() {
      try {
        const res = await axios.get(
            "/education/officeropenrecruitment/apply/dateconfig");
        const list = res.data || [];
        list.forEach((cfg) => {
          if (cfg.type === 1) {
            this.officer_start_date = cfg.start_date;
            this.officer_end_date = cfg.end_date;
          } else if (cfg.type === 3) {
            this.coord_start_date = cfg.start_date;
            this.coord_end_date = cfg.end_date;
          }
        });
      } catch (e) {
        console.error("loadPeriodConfig error => ", e);
      }
    },

    // ==========================
    // 사관학교 기간 저장
    // PATCH /api/v1/education/officeropenrecruitment/apply/dateconfig
    // ==========================
    async saveOfficerPeriod() {
      const s = this.officer_start_date;
      const e = this.officer_end_date;

      // 공란 체크
      if (!s || !e) {
        alert("사관학교 접수 기간의 시작일과 종료일을 모두 선택해 주세요.");
        return;
      }

      // 형식 체크
      if (!this.isValidDateStr(s) || !this.isValidDateStr(e)) {
        alert(
            "사관학교 접수 기간은 YYYY-MM-DD 형식의 올바른 날짜로 입력해 주세요."
        );
        return;
      }

      // 시작일/종료일 역전
      if (s > e) {
        alert("사관학교 접수 기간의 시작일이 종료일보다 늦을 수 없습니다.");
        return;
      }
      try {
        await axios.post(
            "/education/officeropenrecruitment/apply/dateconfig",
 {
              type: 1,
              start_date: s,
              end_date: e,
              use_yn: "Y",
            }
        );

        // 코디네이터 기간과 겹침 안내
        if (
            this.coord_start_date &&
            this.coord_end_date &&
            this.isValidDateStr(this.coord_start_date) &&
            this.isValidDateStr(this.coord_end_date) &&
            this.isRangeOverlapped(
                s,
                e,
                this.coord_start_date,
                this.coord_end_date
            )
        ) {
          alert(
              "사관학교 접수 기간이 저장되었습니다. (사관학교와 코디네이터의 접수 기간이 서로 겹침.)"
          );
        }else{
          alert("사관학교 접수 기간이 저장되었습니다.");
        }
      } catch (e) {
        console.error("saveOfficerPeriod error => ", e);
        alert("사관학교 접수 기간 저장 중 오류가 발생했습니다.");
      }
    },

    // ==========================
    // 코디네이터 기간 저장
    // ==========================
    async saveCoordPeriod() {
      const s = this.coord_start_date;
      const e = this.coord_end_date;

      if (!s || !e) {
        alert("코디네이터 접수 기간의 시작일과 종료일을 모두 선택해 주세요.");
        return;
      }

      if (!this.isValidDateStr(s) || !this.isValidDateStr(e)) {
        alert(
            "코디네이터 접수 기간은 YYYY-MM-DD 형식의 올바른 날짜로 입력해 주세요."
        );
        return;
      }

      if (s > e) {
        alert("코디네이터 접수 기간의 시작일이 종료일보다 늦을 수 없습니다.");
        return;
      }

      // if (
      //     this.officer_start_date &&
      //     this.officer_end_date &&
      //     this.isValidDateStr(this.officer_start_date) &&
      //     this.isValidDateStr(this.officer_end_date) &&
      //     this.isRangeOverlapped(
      //         s,
      //         e,
      //         this.officer_start_date,
      //         this.officer_end_date
      //     )
      // ) {
      //   alert(
      //       "사관학교와 코디네이터의 접수 기간이 서로 겹치지 않도록 설정해 주세요."
      //   );
      //   return;
      // }

      try {
        await axios.post(
            "/education/officeropenrecruitment/apply/dateconfig",
             {
              type: 3,
              start_date: s,
              end_date: e,
              use_yn: "Y",
            }
        );

        // 코디네이터 기간과 겹침 안내
        if (
            this.coord_start_date &&
            this.coord_end_date &&
            this.isValidDateStr(this.coord_start_date) &&
            this.isValidDateStr(this.coord_end_date) &&
            this.isRangeOverlapped(
                s,
                e,
                this.coord_start_date,
                this.coord_end_date
            )
        ) {
          alert(
              "코디네이터 접수 기간이 저장되었습니다. (사관학교와 코디네이터의 접수 기간이 서로 겹침.)"
          );
        } else{
          alert("코디네이터 접수 기간이 저장되었습니다.");
        }
      } catch (e) {
        console.error("saveCoordPeriod error => ", e);
        alert("코디네이터 접수 기간 저장 중 오류가 발생했습니다.");
      }
    },

    getTypeName(type) {
      if (type == 1) return "사관(사관학교)";
      else if (type == 2) return "공채(사관학교)";
      else if (type == 3) return "코디네이터";
      else if (type == 4) return "사관학교";
      else return "-";
    },
    loadData(payload) {
      this.$store
        .dispatch("education/req_officeropenrecruitment_apply_list", payload)
        .then((result) => {
          console.log(
            "req_officeropenrecruitment_apply_list result => ",
            result
          );
          this.data_list = result.data;
          this.data_total_count = result.total_count;
        })
        .catch((err) => {
          console.log(" error => ", err);
        });
    },
    onButtonApplyType(type) {
      if (this.apply_type != type) {
        this.apply_type = type;
        this.loadData({
          apply_type: this.apply_type,
          page: 1,
          size: this.PAGE_SIZE,
        });
      } else {
        this.apply_type = type;
      }
    },
    onSearch(text) {
      this.searchtext = text;
      this.loadData({
        apply_type: this.apply_type,
        page: 1,
        size: this.PAGE_SIZE,
        searchtext: this.searchtext,
      });
    },
    handlePageSelected(page) {
      console.log("handlePageSelected => ", page);
      this.loadData({
        apply_type: this.apply_type,
        page: page,
        size: this.PAGE_SIZE,
        searchtext: this.searchtext,
      });
    },
    onSubmitDelete() {
      console.log("onSubmitDelete ==> ", this.checkedValues);
      if (this.checkedValues.length > 0) {
        this.$store
          .dispatch("education/req_remove_officeropenrecruitment_apply_list", {
            idarr: this.checkedValues,
          })
          .then((result) => {
            this.checkedValues = [];
            this.data_list = result.data;
            this.data_total_count = result.total_count;
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
table {
  .col1 {
    width: 64px;
  }
}
.apply-disabled {
  margin-bottom: 24px;

  .period-setting {
    padding: 16px 20px;
    border-radius: 8px;
    border: 1px solid #e2e5ea;
    background-color: #f8fafc;
  }

  .period-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;

    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #1f2933;
    }

    .period-desc {
      margin: 4px 0 0;
      font-size: 13px;
      color: #6b7280;
      line-height: 1.4;
    }
  }

  .period-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .period-card {
    flex: 1 1 260px;
    min-width: 240px;
    padding: 12px 14px;
    border-radius: 8px;
    background-color: #ffffff;
    border: 1px solid #e5e7eb;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
  }

  .period-title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .period-label {
      margin-left: 8px;
      font-size: 13px;
      color: #6b7280;
    }
  }

  .badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid transparent;
  }

  .badge-officer {
    color: #1d4ed8;
    background-color: #eff6ff;
    border-color: #bfdbfe;
  }

  .badge-coord {
    color: #047857;
    background-color: #ecfdf3;
    border-color: #bbf7d0;
  }

  .period-inputs {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 10px;
  }

  .period-input {
    flex: 1 1 auto;
    min-width: 120px;
    padding: 4px 8px;
    font-size: 13px;
    border-radius: 4px;
    border: 1px solid #d1d5db;
    color: #111827;

    &:focus {
      outline: none;
      border-color: #2563eb;
      box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.15);
    }
  }

  .tilde {
    font-size: 13px;
    color: #6b7280;
  }

  .period-actions {
    display: flex;
    justify-content: flex-end;
  }

  .btn-save {
    padding: 4px 10px;
    font-size: 13px;
    border-radius: 4px;
    border: 1px solid #2563eb;
    background-color: #2563eb;
    color: #ffffff;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease;

    &:hover {
      background-color: #1d4ed8;
      border-color: #1d4ed8;
    }

    &:active {
      background-color: #1e40af;
      border-color: #1e40af;
    }
  }
}
</style>
